import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// When we're ready to add error monitoring, install @sentry/react and:
//   1. `import * as Sentry from '@sentry/react';`
//   2. Call `Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN, ... })` here
//      before ReactDOM.createRoot, guarded by a DSN presence check.
//   3. Wrap <App /> in <Sentry.ErrorBoundary fallback={...}>.
// See git history for the full previous implementation (utils/monitoring.js).

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
